<template>
  <v-form ref="userForm" v-model="valid" :lazy-validation="lazy">
    <v-row dense class="mb-2">
      <v-col cols="4">
       <span class="style-16">Name: {{record.name}}</span>
      </v-col>

      <v-col cols="4">
        <span class="style-16">Name: {{record.email}}</span>
      </v-col>

      <v-col cols="4">
        <span class="style-16">Phone: {{record.phoneNumber}}</span>
      </v-col>

      </v-row>

      <v-divider></v-divider>

      <v-row class="mt-2">
      <v-col cols="4">
        <v-text-field
          outlined
          dense
          label="Password (for backoffice)"
          v-model="record.password"
          prepend-icon="mdi-lock"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPassword ? 'text' : 'password'"
          @click:append="showPassword = !showPassword"
        ></v-text-field>
      </v-col>

      <v-col cols="4">
        <v-text-field
          outlined
          dense
          label="User Pin (for offline)"
          v-model="record.userPin"
          prepend-icon="mdi-lock"
          :append-icon="showPin ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPin ? 'text' : 'password'"
          @click:append="showPin = !showPin"
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-btn color="primary" @click="sendData">
          <v-icon left>mdi-content-save</v-icon>Update
        </v-btn>
      </v-col>

      <snackbar ref="snackbar"></snackbar>
    </v-row>
  </v-form>
</template>
  
  
  <script>
export default {
  props: {
    initial: {
      type: Object,
      required: true
    },
    docCreate: {
      type: Boolean
    }
  },
  data: () => ({
    showPassword: false,
    showPin: false,
    record: {},
    userGroups: [],
    valid: false,
    lazy: false,
    sellOnCredit: false,
    inputRules: [v => !!v || "Required"],
    monthlySalesTarget: null,
    stores: [],
    storesArray: [],
    date: new Date().toISOString().substr(0, 10),
    roles: [
      { name: "Subscriber", role: 3 },
      { name: "Admin", role: 2 },
      { name: "Cashier", role: 1 }
    ]
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true
    }
  },
  methods: {
    init(val) {
      if (val) {
        delete val.userPin;
        this.record = { ...val };

        if (val.sellOnCredit == "Y") {
          this.sellOnCredit = true;
        }

        if (val.sellOnCredit == "N") {
          this.sellOnCredit = false;
        }
      }
    },
    setDate(date) {
      this.record.date = date;
    },
    sendData() {
      if (!this.$refs.userForm.validate()) {
        this.$refs.snackbar.show("Please fill all the fields", "red");
        return;
      }

      console.log(this.record, "record");
      this.$store.commit("btnLoader", true);
      this.$emit("data", this.record);
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGroups() {
      const url = "/user-groups";
      const self = this;
      this.$store
        .dispatch("get", url)
        .then(res => {
          self.userGroups = res.ResponseData;
        })
        .catch(() => {});
    }
  },
  created() {
    this.getStores();
    this.getGroups();
  }
};
</script>